/* Breakpoints */

export const DEVICE_MAX_SIZE = {
  xxs: 300,
  xs: 350,
  small: 767,
  medium: 1025,
  large: 9999999,
};

export const DEVICE = {
  xxs: `(max-width: ${DEVICE_MAX_SIZE.xxs}px)`,
  xs: `(max-width: ${DEVICE_MAX_SIZE.xs}px)`,
  small: `(max-width: ${DEVICE_MAX_SIZE.small}px)`,
  medium: `(min-width: ${DEVICE_MAX_SIZE.small}px) and (max-width: ${DEVICE_MAX_SIZE.medium}px)`,
  large: `(min-width: ${DEVICE_MAX_SIZE.medium + 1}px)`,
};
